import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

/**
 * Angular's default strategy reuses a route's component whenever the route config is the same,
 * regardless of param changes — so navigating from /surveys/A/builder to /surveys/B/builder keeps
 * the same SurveyBuilderComponent instance alive with stale data, and skips canDeactivate (since
 * nothing is "leaving"). Forcing a fresh instance whenever the :id param changes fixes both: pages
 * reload via their normal ngOnInit, and unsaved-changes guards fire again as expected.
 */
export class SurveyRouteReuseStrategy implements RouteReuseStrategy {
  shouldDetach(): boolean {
    return false;
  }

  store(): void {
  }

  shouldAttach(): boolean {
    return false;
  }

  retrieve(): DetachedRouteHandle | null {
    return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.routeConfig !== curr.routeConfig) return false;
    return future.paramMap.get('id') === curr.paramMap.get('id');
  }
}
